<template>
    <div class="home-page">
		<Header></Header>
		<div class="mission" v-if="!notFound">
      <div class="mission-content">
        <div class="redeem-list">
          <div class="redeem-ul">
            <div class="mission-t redeem-t" style="font-size: 52px;">
              {{$t('redeemCenter')}}
            </div>
            <div class="fs27 reddem-font">{{$t('redeemTips1')}}</div>
            <div class="redeem-ul-div flex">
              <div class="redeem-li" v-for="(item,index) in list" :class="'redeem-li'+index" @click="getRedeem(item)">
                <div class="name">TOP UP<br /> {{item.call_charges}}</div>
                <div class="button active ac">{{item.need_score}}</div>
              </div>
            </div>
            <div class="ac crfff w556">***<br />{{$t('redeemTips2')}}</div>


            <div class="point-history lucky-li mt50" v-if="list2.length>0">
              <div class="point-t ac disflex">
                <span class="point-one1">{{$t('Scores')}}</span>
                <span class="point-one2">{{$t('Prize')}}</span>
                <span class="point-one1">{{$t('Status')}}</span>
              </div>
              <div class="point-c">
                <div class="point-li ac disflex" v-for="(item,index) in list2">
                  <span class="point-one1">{{item.use_score}}</span>
                  <span class="point-one2">{{item.call_charges}}</span>
                  <span class="point-one2">{{item.status_text}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Dialog ref="saveDialog" :callback="saveModal" title="Reminder" :btnText="$t('Yes')" :cancelText="$t('No')">
          <div slot="mdBox">
              <div class="redeem-content" v-if="isShow">
                <div class="fs27 mb20">{{$t('redeemTips3')}}</div>
                <div class="redeem-li0" style="width:229px;">
                  <div class="name">{{info.title}}</div>
                </div>
                <div class="fs27">{{$t('redeemTips41')}}{{info.title}}ks. {{info.need_score}} {{$t('redeemTips5')}}</div>
              </div>
              <div class="redeem-content" v-if="isShow2">
                <img src="../../static/images/success.png">
                <div class="mb20 mt20 fs60 fw7">{{$t('redeemTips6')}}</div>
                <div class="fs27">{{msg}}
                </div>
              </div>
              <div class="redeem-content" v-if="isShow3">
                <img src="../../static/images/error.png">
                <div class="mb20 mt20 fs60 fw7">{{$t('redeemTips7')}}</div>
                <div class="fs27">{{msg}}</div>
              </div>
          </div>
      </Dialog>
		</div>
	</div>
</template>
<script>
import Header from '../components/header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {

    return {
			notFound:false,
			list:[],
			isShow:true,
			isShow2:false,
			isShow3:false,
      info:{},
      msg:'',
      id:'',
      list2:[],
			page_id:1,
			page_size:10,
			isShow:'All',
		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
		this.getList2();
		//$utils.spot(money)
	},
    methods: {
		back(){
			this.$router.push({path:'/'})
		},
    getRedeem(item){
      let that = this
      that.id = item.id
      that.isShow = true
      that.isShow2 = false
      that.isShow3 = false
      that.info = item
      console.log(item)
      that.$refs.saveDialog.showMaskFun();

    },
    // 弹框保存
    saveModal (){
      let that = this
      if(that.isShow2||that.isShow3){
        that.$refs.saveDialog.closeMask();
        that.isShow2 = false
        that.isShow3 = false
        return
      }
      let data = {
        id:that.id
      }
      that.isShow2 = false
      that.isShow3 = false
      that.$parent.loadModal(true);
      that.$api.post('/api/integral/exchange',data,r =>{
      	if(r.code==0){
          that.isShow3 = true
        }else{
          that.isShow2 = true
        }
        that.msg = r.msg
        that.isShow = false
        //that.$refs.saveDialog.closeMask();
        that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);

        });

      })

    },
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			that.$api.get('/api/integral/list',null,r =>{
				that.$parent.returnCode(r,function(){
					that.list = r.data
					that.$parent.loadModal(false);

       });

			})
		},
    getList2(){
        let that =this;
       // / that.$parent.loadModal(true);
        that.$api.get('/api/integral/exchangelog',null,r =>{
          that.$parent.returnCode(r,function(){
            that.$parent.loadModal(false);
            if(r.data.length>0){
              that.list2 = r.data
            }else{
              that.isShow = false;
          }
        });
      })
    },
		getMore(){
			let that = this;
			if(that.isShow){
				that.page_id++;
				that.getList2();
			}else{
				//that.$utils.alertText(that.$t('noMore'));
			}
		},
    getList(item){
      this.isShow = item
    }
	}
}
</script>
<style>
  .fs60{font-size:60px;}
</style>



// WEBPACK FOOTER //
// src/page/redeemCenter.vue